(function (){
    'use strict';

    angular
        .module('services')
        .service('AccountService', AccountService);

    AccountService.$inject = ['$http', 'API_BASE'];

    function AccountService ($http, API_BASE) {
        var service = this;

        service.getAccountsTravelExpenses = getAccountsTravelExpenses;
        service.getAccountsCommissions = getAccountsCommissions;
        service.getBankAccounts = getBankAccounts;
        
        function getAccountsTravelExpenses() {
            return $http.get(API_BASE + '/account/travel_expenses');
        }

        function getAccountsCommissions() {
            return $http.get(API_BASE + '/account/commissions');
        }

        function getBankAccounts() {
            return $http.get(API_BASE + '/account/bank');
        }
    }
})();